// Shared color tokens. Keep these references in mind when adding new pages
// so the palette stays consistent.
export const colors = {
  primary: "#1a5fb4",
  primaryBg: "#e8f0fe",
  success: "#1a7f37",
  successBg: "#c9efc9",
  danger: "#c12c2c",
  dangerBg: "#f8d7da",
  warning: "#9a6b00",
  warningBg: "#fff3cd",
  border: "#d1d5db",
  borderSoft: "#e5e7eb",
  text: "#222",
  textMuted: "#666",
  textFaint: "#888",
  cardBg: "#f9f9f9",
  pageBg: "#fff",
  accentBg: "#f4f8ff",
};

// Typography recipes. Use these instead of hand-picking font sizes so the
// app stays visually consistent and the responsive pass has one place to
// scale text. Headings 1–4 are already applied globally via index.css; the
// heading entries here are for cases where you can't use a real <h*> tag.
export const text = {
  body: { fontSize: "14px", lineHeight: 1.45 },
  small: { fontSize: "13px", lineHeight: 1.4 },
  tiny: { fontSize: "12px", lineHeight: 1.35 },
  label: { fontSize: "13px", fontWeight: 600, lineHeight: 1.4 },
  muted: { fontSize: "13px", color: colors.textMuted },
  heading1: { fontSize: "24px", fontWeight: 700, lineHeight: 1.2 },
  heading2: { fontSize: "20px", fontWeight: 700, lineHeight: 1.25 },
  heading3: { fontSize: "16px", fontWeight: 600 },
  heading4: { fontSize: "14px", fontWeight: 600 },
};

export const styles = {
  page: {
    padding: "20px",
    maxWidth: "960px",
    margin: "0 auto",
    color: colors.text,
  },

  card: {
    border: `1px solid ${colors.borderSoft}`,
    borderRadius: "8px",
    padding: "14px",
    marginBottom: "12px",
    background: colors.cardBg,
  },

  // Neutral button — subtle grey chip, dark text. Color overrides
  // (`{ ...styles.button, background: ..., color: ... }`) still work; the
  // border stays soft enough to not clash with whatever fill is applied.
  button: {
    padding: "8px 14px",
    margin: "4px",
    cursor: "pointer",
    background: "#f3f4f6",
    color: colors.text,
    border: `1px solid ${colors.border}`,
    borderRadius: "4px",
    ...text.small,
    fontWeight: 500,
  },

  // Filled blue primary action — use for the single most important action
  // on a page (e.g. Save, Send, Finalize).
  primaryButton: {
    padding: "8px 14px",
    margin: "4px",
    cursor: "pointer",
    background: colors.primary,
    color: "white",
    border: `1px solid ${colors.primary}`,
    borderRadius: "4px",
    ...text.small,
    fontWeight: 600,
  },

  input: {
    padding: "8px 10px",
    margin: "4px 0",
    width: "100%",
    maxWidth: "400px",
    border: `1px solid ${colors.border}`,
    borderRadius: "4px",
    ...text.body,
    boxSizing: "border-box",
    background: "white",
    color: colors.text,
  },

  textarea: {
    padding: "8px 10px",
    margin: "4px 0",
    width: "100%",
    maxWidth: "500px",
    border: `1px solid ${colors.border}`,
    borderRadius: "4px",
    ...text.body,
    boxSizing: "border-box",
    background: "white",
    color: colors.text,
    fontFamily: "inherit",
  },
};
